import 'core-js/stable';
import 'regenerator-runtime/runtime';

import { ready } from './utils/dom';
import { init as nav } from './modules/nav';
import { init as siteHeader } from './modules/site-header';
import { gallery } from './modules/gallery';
import { testimonialCarousel } from './modules/testimonials-carousel';
import { scrollToLinks } from './modules/scroll-to-links';
import { accordionFunc } from './modules/accordion';
import { videoLoader } from './modules/video';
import { toggle } from './modules/toggle';
import { init as cookieConsent } from './modules/cookie-consent';
import AOS from 'aos';
import LazyLoader from './modules/lazy-loader';

ready(function onReady() {
	init();
});

function init() {
	toggle();
	siteHeader();
	nav();
	LazyLoader().update();
	videoLoader();
	scrollToLinks();
	gallery();
	testimonialCarousel();
	accordionFunc();
	cookieConsent();
	AOS.init();
}
